import React, {Component} from 'react';
import { View ,ActivityIndicator} from 'react-native';

import Colors from "../tools/Colors";

export default class HMLoading extends Component {

    render() {
        const {style, text, icon, navigateParams} = this.props;
        return (
            <View style={[style?style:{flex: 1,justifyContent:'center',alignItems:'center'}]}>
                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>
            </View>
        );
    }

}
